import { useTranslation } from 'react-i18next';
import { getUnitLevelLabel } from '../../Utils/unitSelectLabels';
import { useAllUnits } from '../../Hooks/admin/useUnit';
import { FormFieldConfig } from '../../Hooks/useForm';
import { AccessTypeKey } from '../../Types/access';
import { Unit } from '../../Types/unit';
import { BizParentSelect, BizSelect } from './BizSelect';

type BizUnitSelectProps = {
	showTypeLabels?: boolean;
	selectedId: number | string | null | undefined;
	onChange: (unit: Unit | null) => void;
	direction?: 'horizontal' | 'vertical';
	noSelectText?: string;
	childNoSelectText?: string;
	accessTypeKey: AccessTypeKey | null;
	formConfig?: FormFieldConfig;
	name?: string;
	disabled?: boolean;
	autoSelectSingleOption?: boolean;
};

const BizUnitSelect = ({
	showTypeLabels = false,
	selectedId,
	onChange,
	direction = 'vertical',
	noSelectText = 'Select unit',
	childNoSelectText = 'All child units',
	accessTypeKey,
	formConfig,
	name,
	disabled,
	autoSelectSingleOption = true,
}: BizUnitSelectProps) => {
	const { t } = useTranslation();
	const labelFor = (units: Unit[]) => getUnitLevelLabel(units, t('UNIT_SELECT.UNIT', { defaultValue: 'Unit' }));
	const allUnits = useAllUnits(accessTypeKey);
	const isFlatUnitList = new Set((allUnits ?? []).map((unit) => unit.ParentId ?? null)).size <= 1;

	if (isFlatUnitList) {
		return (
			<BizSelect
				label={showTypeLabels ? labelFor(allUnits ?? []) : undefined}
				options={allUnits ?? []}
				selectedId={selectedId}
				onChange={(unit) => onChange(unit || null)}
				noSelectText={noSelectText}
				className='form-control'
				formConfig={formConfig}
				name={name}
				disabled={disabled}
				autoSelectSingleOption={autoSelectSingleOption}
			/>
		);
	}

	return (
		<BizParentSelect
			getLevelLabel={showTypeLabels ? labelFor : undefined}
			options={allUnits ?? []}
			selectedId={selectedId}
			onChange={(unit) => onChange(unit || null)}
			noSelectText={noSelectText}
			childNoSelectText={childNoSelectText}
			childClassName='form-control'
			direction={direction}
			formConfig={formConfig}
			name={name}
			disabled={disabled}
		/>
	);
};

export default BizUnitSelect;
